import { Component, Input } from '@angular/core';
import { ScrollToService } from '../../shared';
import { FaqCategory } from '../faq.model';

@Component({
  selector: 'jhi-faq-summary',
  templateUrl: './faq-summary.component.html',
  styleUrls: ['./faq-summary.component.scss']
})
export class FaqSummaryComponent {

  @Input() categories: Array<FaqCategory>;

  constructor(private scrollToService: ScrollToService) { }

  scrollToCategory(categoryId: number) {
    this.scrollToService.scrollBySelector(`.faq-category-` + categoryId);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq-summary/faq-summary.component.ts